import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Typography, CircularProgress
} from '@mui/material';

export default function TablecomponentAnalytics({ chartData, loader, title }) {
  console.debug("tablecomponent: users", { chartData });

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  let usersWeek = [];

  if (title === 'Clicks' && chartData?.week_wise) {
    // ---------- CLICKS FLOW ----------
    usersWeek = Object.entries(chartData.week_wise)
      .flatMap(([week, entry]) =>
        (entry?.users || []).map(user => {
          const dateStr = user?.last_clicked;
          const dateObj = dateStr ? new Date(dateStr) : null;

          return {
            week,
            user,
            month: dateObj
              ? dateObj.toLocaleString('default', { month: 'long' })
              : 'N/A',
            year: dateObj ? dateObj.getFullYear() : null,
            monthIndex: dateObj ? dateObj.getMonth() : null,
          };
        })
      )
      .filter(row => row.monthIndex === currentMonth && row.year === currentYear);
  } else if (title === 'Applied' && chartData?.applications_by_week) {
    // ---------- APPLIED FLOW ----------
    usersWeek = Object.entries(chartData.applications_by_week)
      .flatMap(([week, entry]) =>
        (entry?.users || []).map(user => {
          const dateStr = user?.last_applied;
          const dateObj = dateStr ? new Date(dateStr) : null;

          return {
            week,
            user,
            month: dateObj
              ? dateObj.toLocaleString('default', { month: 'long' })
              : 'N/A',
            year: dateObj ? dateObj.getFullYear() : null,
            monthIndex: dateObj ? dateObj.getMonth() : null,
          };
        })
      )
      .filter(row => row.monthIndex === currentMonth && row.year === currentYear);
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ maxWidth: '120px', fontWeight: 600 }}>Name</TableCell>
            <TableCell sx={{ maxWidth: '150px', fontWeight: 600 }}>Email</TableCell>
            <TableCell sx={{ maxWidth: '150px', fontWeight: 600 }}>Week</TableCell>
            <TableCell sx={{ maxWidth: '150px', fontWeight: 600 }}>Month</TableCell>
            <TableCell sx={{ maxWidth: '150px', fontWeight: 600 }}>Day</TableCell>
            <TableCell sx={{ maxWidth: '150px', fontWeight: 600 }}>
              {title === "Clicks" ? 'Last Clicked' : 'Last Applied'}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loader ? (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <CircularProgress />
                </Box>
              </TableCell>
            </TableRow>
          ) : usersWeek.length > 0 ? (
            usersWeek.map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={{ maxWidth: '150px' }}>
                  {row?.user?.name || "Unknown"}
                </TableCell>
                <TableCell sx={{ maxWidth: '150px' }}>
                  {row?.user?.email || "N/A"}
                </TableCell>
                <TableCell sx={{ maxWidth: '150px' }}>
                  {row?.week || 0}
                </TableCell>
                <TableCell sx={{ maxWidth: '150px' }}>
                  {row?.month}
                </TableCell>
                <TableCell sx={{ maxWidth: '150px' }}>
                  {row?.user?.day || "N/A"}
                </TableCell>
                <TableCell sx={{ maxWidth: '150px' }}>
                  {title === "Clicks"
                    ? (row?.user?.last_clicked || "N/A")
                    : (row?.user?.last_applied || "N/A")}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Typography>No Data</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
